import merge from "lodash/merge";
import striptags from "striptags";
import decode from "unescape";

import api from "./api";
import config from "../config";
import moment from "moment-timezone";

function prepareShortDescription(shortDescription) {
  let formatted = shortDescription.replace(/\&nbsp;/g, " ");

  if (typeof TENANT !== "undefined" && TENANT.sundance_login) {
    formatted = decode(striptags(formatted || "", [], " "));
  }

  return formatted;
}

function processFilm(film) {
  let shortDescription =
    film.short_description ||
    decode(striptags(film.description || "", [], " "));
  film.short_description = prepareShortDescription(shortDescription);
  return film;
}

function processEvent(event) {
  let shortDescription =
    event.short_description ||
    decode(striptags(event.description || "", [], " "));

  if (!event.short_description && event.films.length) {
    shortDescription +=
      (shortDescription ? " | " : "") +
      event.films
        .map(f => processFilm(f).short_description)
        .filter(x => !!x)
        .join(" | ");
  }

  shortDescription =
    prepareShortDescription(shortDescription)
      .substring(0, 500)
      .replace(/\s+/, " ")
      .replace(/\s+$/, "") + (shortDescription.length > 500 ? "..." : "");

  // If virtual screening with only a still image, use that
  if (!event.images.cover && event.images.still) {
    event.images.cover = event.images.still;
  }

  // Inject film cover image if none provided
  if (!event.images.cover && event.films.length) {
    let covers = event.films.filter(f => f && f.cover_image);
    if (covers.length) {
      event.images.cover = covers[0].cover_image;
    } else {
      // Fallback to film still image if no cover provided
      let stills = event.films.filter(f => f && f.still_image);
      if (stills.length) {
        event.images.cover = stills[0].still_image;
      }
    }
  }

  // Only publicly visible ticket buckets
  event.ticket_buckets = event.ticket_buckets.filter(b => !!b.public);

  return merge(
    event,
    event.ticket_buckets.length
      ? {
          price: event.ticket_buckets[0].price
        }
      : {},
    {
      short_description: shortDescription
    }
  );
}

export default {
  processFilm,

  fetchAllFilms(person, { forceAll }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/${config.event_bucket}/films`,
          qs: {
            marquee: !forceAll && TENANT.marquee_enabled ? true : undefined
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve({
            films: response.films.map(processFilm)
          });
        }
      );
    });
  },

  fetchOneFilm(person, film) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `films/${film}`,
          qs: {
            marquee: TENANT.marquee_enabled ? true : undefined
          }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(processFilm(response));
        }
      );
    });
  },

  fetchAll(person, opts) {
    console.log("EventFetcher fetchAll options");
    console.log(opts);
    return new Promise((resolve, reject) => {
      let usePost = opts.eventIds && opts.eventIds.length > 50;
      api.request(
        {
          method: usePost ? "POST" : "GET",
          endpoint: `event_buckets/${config.event_bucket}/${
            usePost ? "events_get" : "events"
          }`,
          [usePost ? "json" : "qs"]: {
            // token: person,
            upcoming_only: !opts.includePastEvents ? true : undefined,
            include_undated_virtual: opts.includeVirtualEvents
              ? true
              : undefined,
            marquee:
              TENANT.marquee_enabled && !window.EVENTIVE_IS_EVERYWHERE
                ? true
                : undefined,
            event_ids: opts.eventIds ? JSON.stringify(opts.eventIds) : undefined
          }
        },
        function (err, response) {
          console.log("EventFetcher fetchAll response");
          console.log(response);
          if (err) {
            console.log(err)
            return reject(err);
          }
          resolve({
            events: response.events.map(processEvent),
            includes_all_events: response.includes_all_events
          });
        }
      );
    });
  },

  fetchAllForFilm(person, filmId) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/${config.event_bucket}/films/${filmId}/events`,
          qs: TENANT.marquee_enabled ? { marquee: true } : undefined
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve({
            events: response.events.map(processEvent)
          });
        }
      );
    });
  },

  fetchOne(person, event) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `events/${event}`,
          qs: { token: person }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(processEvent(response));
        }
      );
    });
  },

  fetchMarquee(date) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `event_buckets/${config.event_bucket}/upcoming?date=${moment(date).toISOString()}`
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          response.films = response.films.map(processFilm);
          Object.values(response.standalone_events).map(e => processFilm(e));
          resolve(response);
        }
      );
    });
  },

  fetchOneVirtual(person, event) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `watch/events/${event}`,
          qs: { token: person }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  playVirtualEvent(person, ticket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `whitelabel/begin_playback`,
          json: { token: person, ticket_id: ticket }
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/EventFetcher.js